export default __webpack_public_path__ + "static/media/jsx2.7304d8d1.png";